module.exports = __webpack_public_path__ + "static/cta_blog_index@2x-8b64e544dcd06a36e6bcfd60d826314e.jpg";